var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Icon from "./icon.svg";
var Native = Icon;
var Web = function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 141.73 141.73" }),
    React.createElement("g", { id: "Capa_2", "data-name": "Capa 2" },
        React.createElement("g", { id: "Capa_1-2", "data-name": "Capa 1" },
            React.createElement("rect", { width: "141.73", height: "141.73", rx: "34.98", fill: "#c31c37" }),
            React.createElement("path", { d: "M88.12,73H23.42a2.16,2.16,0,1,1,0-4.31h64.7a2.16,2.16,0,1,1,0,4.31Z", fill: "#fff" }),
            React.createElement("path", { d: "M70.87,90.28a2.16,2.16,0,0,1-1.53-3.68L85.07,70.87,69.34,55.14a2.16,2.16,0,0,1,3-3L89.65,69.34a2.16,2.16,0,0,1,0,3L72.39,89.65A2.14,2.14,0,0,1,70.87,90.28Z", fill: "#fff" }),
            React.createElement("path", { d: "M73,118.32A47.52,47.52,0,0,1,28.28,86.68a2.16,2.16,0,0,1,4.07-1.43,43.14,43.14,0,1,0,0-28.76,2.15,2.15,0,0,1-4.06-1.44A47.45,47.45,0,1,1,73,118.32Z", fill: "#fff" }))))); };
export default { Native: Native, Web: Web };
